/* global $ */

import jumpToElement from './jumpToElement';

const $sliders = $('.js-slider, .js-card-reviews, .js-journey-highlights');

const TABS_SELECTOR = '.js-tabs';
const TABS_SCROLL_SELECTOR = '.js-tabs .nav-tabs';
const TAB = '.js-tabs .nav-link';
const TAB_TOGGLER_SELECTOR = '.js-tab-toggler';
const TABS_PREV_SELECTOR = '.js-tabs-prev';
const TABS_NEXT_SELECTOR = '.js-tabs-next';

const tabs = {
  initialize() {
    if ($(TABS_SELECTOR).length) {
      this.createListeners();
    }
  },

  createListeners() {
    const { hash } = window.location;

    if (typeof hash !== 'undefined') {
      $(TABS_SELECTOR).find(`a[href="${hash}"]`).tab('show');
    }

    $(TAB).on('shown.bs.tab', () => {
      $sliders.toArray().forEach((slider) => {
        $(slider).slick('setPosition');
      });
    });

    $(TABS_SELECTOR).on('click', 'a', ({ currentTarget }) => {
      $(currentTarget).tab('show');
      this.changeToHash(currentTarget.hash);
    });

    $(TAB_TOGGLER_SELECTOR).on('click', ({ currentTarget }) => {
      $(TABS_SELECTOR).find(`a[href="${currentTarget.dataset.tabTarget}"]`).tab('show');

      this.changeToHash(currentTarget.dataset.tabTarget);
      jumpToElement.handleJump('.js-breadcrumb', 0);
    });

    $(TABS_PREV_SELECTOR).on('click', () => {
      const scrollContainer = document.querySelector(TABS_SCROLL_SELECTOR);

      const currentScrollLeft = scrollContainer.scrollLeft;
      const nextScrollLeft = currentScrollLeft - 100;

      scrollContainer.scrollTo({
        left: nextScrollLeft,
        behavior: 'smooth',
      });
    });

    $(TABS_NEXT_SELECTOR).on('click', () => {
      const scrollContainer = document.querySelector(TABS_SCROLL_SELECTOR);

      const currentScrollLeft = scrollContainer.scrollLeft;
      const nextScrollLeft = currentScrollLeft + 100;

      scrollContainer.scrollTo({
        left: nextScrollLeft,
        behavior: 'smooth',
      });
    });

    $(TABS_SCROLL_SELECTOR).on('scroll', () => {
      this.checkArrowVisibility();
    });
  },

  changeToHash(hash) {
    if (!window.history || typeof window.history.replaceState !== 'function') {
      return;
    }

    window.history.replaceState(null, null, hash);
  },

  checkArrowVisibility() {
    const scrollContainer = document.querySelector(TABS_SCROLL_SELECTOR);

    const { scrollLeft } = scrollContainer;

    const showPrev = scrollLeft > 0;
    const showNext = scrollLeft < scrollContainer.scrollWidth - scrollContainer.clientWidth;

    document.querySelector(TABS_SELECTOR).classList[showPrev ? 'add' : 'remove']('show-prev');
    document.querySelector(TABS_SELECTOR).classList[showNext ? 'add' : 'remove']('show-next');
  },
};

export default tabs;
